// ----------------------------------------------------------------------

const users = [
  {
    id: 1,
    title: 'Mr.',
    name: 'John',
    lname: 'Smith',
    attendeetype: 'Local',
    email: 'john.smith@mail.com',
    password: 'qwerty123',
    subdate: '2022-01-16 18:47 UTC',
    status: 'Active',
    appstatus: 'Link Sent',
    namearabic: '',
    lnamearabic: '',
    organizationname: '',
    jobtitle: '',
    countrycode: '',
    contactnumber: '',
    fullname: '',
    bio: '',
    nationality: '',
    passportnumber: '',
    dateofissue: '',
    dateofexpire: '',
    passportdoc: '',
    passportphoto: '',
    airportofdeparture: '',
    countryofdeparture: '',
    preference: '',
    visa: '',
    smokingrequired: '',
    twitter: '',
    country: '',
    city: '',
    role: '',
    rsvp: '',
    rsvpcomments: '',
    statusremark: '',
    invitationtype: '',
    registrationtype: '',
    transportation: '',
    transportcomments: '',
    airlinename: '',
    airlinebknumber: '',
    hotelbknumber: '',
    chekin: '',
    checkout: '',
    linkexpire: ''
  },
  {
    id: 2,
    title: 'Mrs.',
    name: 'Ewa',
    lname: 'Brown',
    password: 'qwerty123',
    attendeetype: 'International',
    email: 'ewa.brown@mail.com',
    subdate: '2022-01-16 18:47 UTC',
    status: 'Inactive',
    appstatus: 'Link Sent',
    namearabic: '',
    lnamearabic: '',
    organizationname: '',
    jobtitle: '',
    countrycode: '',
    contactnumber: '',
    fullname: '',
    bio: '',
    nationality: '',
    passportnumber: '',
    dateofissue: '',
    dateofexpire: '',
    passportdoc: '',
    passportphoto: '',
    airportofdeparture: '',
    countryofdeparture: '',
    preference: '',
    visa: '',
    smokingrequired: '',
    twitter: '',
    country: '',
    city: '',
    role: '',
    rsvp: '',
    rsvpcomments: '',
    statusremark: '',
    invitationtype: '',
    registrationtype: '',
    transportation: '',
    transportcomments: '',
    airlinename: '',
    airlinebknumber: '',
    hotelbknumber: '',
    chekin: '',
    checkout: '',
    linkexpire: ''
  },
  {
    id: 3,
    title: 'Mrs.',
    name: 'Ewa',
    lname: 'Brown',
    password: 'qwerty123',
    attendeetype: 'International',
    email: 'ewa.brown@mail.com',
    subdate: '2022-01-16 18:47 UTC',
    status: 'Inactive',
    appstatus: 'Link Sent',
    namearabic: '',
    lnamearabic: '',
    organizationname: '',
    jobtitle: '',
    countrycode: '',
    contactnumber: '',
    fullname: '',
    bio: '',
    nationality: '',
    passportnumber: '',
    dateofissue: '',
    dateofexpire: '',
    passportdoc: '',
    passportphoto: '',
    airportofdeparture: '',
    countryofdeparture: '',
    preference: '',
    visa: '',
    smokingrequired: '',
    twitter: '',
    country: '',
    city: '',
    role: '',
    rsvp: '',
    rsvpcomments: '',
    statusremark: '',
    invitationtype: '',
    registrationtype: '',
    transportation: '',
    transportcomments: '',
    airlinename: '',
    airlinebknumber: '',
    hotelbknumber: '',
    chekin: '',
    checkout: '',
    linkexpire: ''
  }
];
export default users;
